export const ADD_QUOTATION = 'ADD_QUOTATION';
export const FETCH_QUOTATIONS_COMPLETED = 'FETCH_QUOTATIONS_COMPLETED';
export const FETCH_QUOTATIONS_ERROR = 'FETCH_QUOTATIONS_ERROR';
export const FETCH_QUOTATIONS_STARTED = 'FETCH_QUOTATIONS_STARTED';

export const UPDATE_QUOTATIONS_CURRENT_PAGE = 'UPDATE_QUOTATIONS_CURRENT_PAGE';
export const UPDATE_QUOTATIONS_PAGE_SIZE = 'UPDATE_QUOTATIONS_PAGE_SIZE';

export const ADD_SEARCH_STRING = 'ADD_SEARCH_STRING';
export const CLEAR_SEARCH_STRING = 'CLEAR_SEARCH_STRING';

export const SORT_QUOTATIONS = 'SORT_QUOTATIONS';
export const CLEAR_QUOTATIONS = 'CLEAR_QUOTATIONS';
